<template>
  <div 
    class="gp-loader absolute w-full h-full flex flex-col justify-center items-center"
    :class="{
      'color-2': hasState('dark') && !hasState('transparent'),
      'color-1': !hasState('dark') && !hasState('transparent'),
	  'transparent-2': hasState('transparent') && hasState('dark'),
	  'transparent-1': hasState('transparent') && !hasState('dark')
    }"
  >
	<span class="text-grey-500 font-thin mb-1" v-if="label">{{label}}</span>

    <svg v-if="groove"
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 40 40"
      class="groove-logo speed-1"
    >
      <path d="M19.722 19.852h19.326c-.829 8.975-4.942 14.896-12.34 17.763-7.397 2.866-14.386 1.433-20.966-4.3l6.906-6.626c2.51 1.84 4.869 2.76 7.074 2.76 2.206 0 4.268-.844 6.186-2.532l-6.186-7.065zM0 19.36h9.909c.391-4.854 2.702-7.9 6.933-9.137 4.23-1.236 7.798.038 10.702 3.822l7.73-6.309C28.764.456 21.24-1.686 12.701 1.312 4.814 4.08.581 10.097 0 19.36z"></path>
    </svg>

	<half-circle-spinner v-else :animation-duration="1000" :dot-size="15" :dots-num="3" color="#FD6481" class="gd-loader--spinner" />
  </div>
</template>

<script>
import mixins from '../mixins';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
	mixins: [mixins],
	props: {
		dark: {
			type: Boolean,
			default: false
		},
		transparent: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		groove: {
			type: Boolean,
			default: true
		}
	}
};
</script>

<style lang="scss">
.gp-loader {
	top: 0;
	left: 0;
	z-index: 48;
	flex-direction: column;

	.label {
  		font-weight: 200;
  		color: #a4a8c0;
	}

	.groove-logo {
		height: 60px;
		width: 60px;
		stroke: #FD6481;
		fill: #FD6481;
		stroke-dasharray: 600;
		stroke-width: .6;
		opacity: 1;
		animation: pinkIt 5s cubic-bezier(0, 0.23, 1, .1) infinite;
		animation-delay: 0s;
		-moz-animation: pinkIt 5s cubic-bezier(0, 0.23, 1, .1) infinite;
		-webkit-animation: pinkIt 5s cubic-bezier(0, 0.23, 1, .1) infinite;
		stroke-linecap: round;
		margin: 5px auto 15px;
	}
	
	@keyframes pinkIt {
		0%,
		100% {
			fill: none;
			stroke-dashoffset: 600;
			fill: rgba(255, 255, 255, 0);
			opacity: 0;
		}
	
		20% {
			fill: rgba(255, 255, 255, 0);
			opacity: 1;
			stroke-dashoffset: 600;
		}
	
		60% {
			fill: #FD6481;
			stroke-dashoffset: 0;
		}
	}

	&.color-1 {background-color: #DCDCEA;}
	&.color-2 {background-color: #191C3C;}
	&.transparent-1 {background-color: #dcdceaae;}
	&.transparent-2 {background-color: #191c3c80;}

	&.transparent-2,&.color-2 {
		span {color: #DCDCEA;}
		.label {color: white;}
	}
}
</style>
